import React, { useEffect } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { MarqueeBanner, Footer } from "../components/Sections";
import { LEGAL_PAGES } from "../legalContent";
import { usePageTracking } from "../analytics";
import { ArrowLeft } from "lucide-react";

const Block = ({ block }) => {
  if (block.type === "p") {
    return (
      <p className="legal-p">
        {block.text}
        {block.email && (
          <a href={`mailto:${block.email}`} className="legal-email">
            {block.email}
          </a>
        )}
        {block.email ? "." : ""}
      </p>
    );
  }
  if (block.type === "lead") {
    return <p className="legal-p legal-lead">{block.text}</p>;
  }
  if (block.type === "ul") {
    return (
      <ul className="legal-ul">
        {block.items.map((item, i) => {
          if (block.boldPrefix && item.includes(": ")) {
            const idx = item.indexOf(": ");
            return (
              <li key={i}>
                <strong className="text-white">{item.slice(0, idx + 1)}</strong>{" "}
                {item.slice(idx + 2)}
              </li>
            );
          }
          return <li key={i}>{item}</li>;
        })}
      </ul>
    );
  }
  return null;
};

const LegalPage = ({ slug: slugProp }) => {
  const params = useParams();
  const slug = slugProp || params.slug;
  const page = LEGAL_PAGES[slug];

  usePageTracking(slug || "legal");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!page) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-black">
      <MarqueeBanner />
      <main className="mx-auto max-w-3xl px-5 pb-20 pt-14">
        <Link to="/" className="legal-back">
          <ArrowLeft size={15} />
          Back to Application
        </Link>
        <h1 className="mt-6 text-4xl font-semibold tracking-tight text-white sm:text-5xl">
          <span className="text-[#16E36F]">{page.title.split(" ")[0]}</span>{" "}
          {page.title.split(" ").slice(1).join(" ")}
        </h1>
        <div className="mt-10 space-y-10">
          {page.sections.map((section, i) => (
            <section key={i}>
              <h2 className="mb-3 text-xl font-semibold text-white">
                {section.heading}
              </h2>
              {section.blocks.map((block, j) => (
                <Block key={j} block={block} />
              ))}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
